import { Components } from '@mui/material'

export function OverridedDivider(): Components {
  return {
    MuiDivider: {
      styleOverrides: {
        root: {
          '&.MuiDivider-middle.MuiDivider-vertical': {
            margin: '12px -2px 12px 0',
          },
        },
      },
    },
  }
}
